// extracted by mini-css-extract-plugin
module.exports = {"component":"about-us_component__A0oj1"};